// Internal modules
const calculateCookieBannerHeight = (defaultValue = 0): number => {
  const cookieBanner = document.querySelector('#cookie-banner-container > div');
  // @ts-expect-error type cookieBanner
  return cookieBanner?.offsetHeight || defaultValue;
};

export { calculateCookieBannerHeight };
